

export const changeTitle = (newTitle: string) => {
  dispatchEvent(new CustomEvent(`CHANGE_TITLE_EVENT`, {
    detail: newTitle,
  }));
}
